import { ec as EC } from 'elliptic';

// Types
export interface Friend { name: string; publicKey: string; }
export type Conversations = Map<string, { name: string }>

// State variables
export let userName: string = 'Anonymous';
export let userKeyPair: EC.KeyPair | null = null;
export let userPublicKey: string | null = null;
export let userFingerprint: string | null = null;
export let friendFingerprintToFilter: string | null = null;
export let personalTopic: string | null = null;
export let friendsList: Map<string, Friend> = new Map();
export let subsList: Map<string, Friend> = new Map();
export let pendingPublicKeyRequests: Map<string, string> = new Map();
export let conversations: Conversations = new Map();
export let activeConversationPartner: string | null = null;
export let incomeMessage: { message: string, name: string }[] = [];

// State setters
export function setUserName(name: string) { userName = name; }
export function setUserKeyPair(keyPair: EC.KeyPair) { userKeyPair = keyPair; }
export function setUserPublicKey(key: string) { userPublicKey = key; }
export function setUserFingerprint(fingerprint: string) { userFingerprint = fingerprint; }
export function setFriendFingerprintToFilter(filter: string | null) { friendFingerprintToFilter = filter; }
export function setPersonalTopic(topic: string) { personalTopic = topic; }
export function setActiveConversationPartner(partner: string | null) { activeConversationPartner = partner; }
